module.exports = __webpack_public_path__ + "static/media/72734201416312710814142-512.4a264544.png";